import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col,
} from "reactstrap";

import Swal from "sweetalert2";
import Baja from "../../Baja";
import ProveedoresInfo from "./ProveedoresInfo"

function TablaProveedores(props) {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_PROVEEDORES_EDIT = `${import.meta.env.VITE_URL_PROVEEDORES}/${props.idProveedor}`;
  const [nombre_comercial, setNombreComercial] = useState(props.nomcom);
  const [razon_social, setRazonSocial] = useState(props.razsoc);
  const [RFC, setRFC] = useState(props.RFC);
  const [contacto, setContacto] = useState(props.contacto);
  const [telefono, setTelefono] = useState(props.telefono);
  const [email, setEmail] = useState(props.email);
  const [login_active, setLoginActive] = useState(props.login_active || false);
  const [password, setPassword] = useState("");
  const [calle, setCalle] = useState(props.calle);
  const [numero_ext, setNumeroExt] = useState(props.numero_ext);
  const [numero_int, setNumeroInt] = useState(props.numero_int);
  const [delegacion, setDelegacion] = useState(props.delegacion);
  const [estado, setEstado] = useState(props.estado);
  const [pais, setPais] = useState(props.pais);
  const [cp, setCP] = useState(props.cp);
  const [colonia, setColonia] = useState(props.colonia);
  const [ciudad, setCiudad] = useState(props.ciudad);
  const [proveedores, setProveedores] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [modalLogin, setModalLogin] = useState(false);
  const toggleLogin = () => setModalLogin(!modalLogin);

  useEffect(() => {
    axios
      .get(URL_PROVEEDORES_EDIT, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editProveedor(event) {
    event.preventDefault();
    axios
      .patch(
        URL_PROVEEDORES_EDIT,
        {
          nombre_comercial,
          razon_social,
          RFC,
          contacto,
          telefono,
          email,
          calle,
          numero_ext,
          numero_int,
          delegacion,
          estado,
          pais,
          cp,
          colonia,
          ciudad,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Proveedor',
            detalle: `Nombre Comercial: ${nombre_comercial}`,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  function editProveedorLogin(event) {
    event.preventDefault();
    axios
      .patch(
        URL_PROVEEDORES_EDIT,
        {
          login_active,
          password: password.trim() !== "" ? password : undefined,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Configurar Login Proveedor',
            detalle: `${nombre_comercial} - Acceso: ${login_active ? 'Habilitado' : 'Deshabilitado'}`,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggleLogin();
        setPassword(""); // Limpiar contraseña
        Swal.fire("Good job!", "Acceso de login actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  return (
    <>
      <td>{props.nomcom}</td>
      <td>{props.razsoc}</td>
      <td>{props.RFC}</td>
      <td>{props.contacto}</td>
      <td>{props.telefono}</td>
      <td>{props.email}</td>
      <td style={{ textAlign: "center" }}>
        {props.login_active ? (
          <span className="badge badge-success">
            <i className="fas fa-check-circle me-1"></i>
            Habilitado
          </span>
        ) : (
          <span className="badge badge-secondary">
            <i className="fas fa-times-circle me-1"></i>
            Deshabilitado
          </span>
        )}
      </td>
      {/* <td style={{ textAlign: "center" }}>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(props.cargos)}</td>
      <td style={{ textAlign: "center" }}>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(props.abonos)}</td>
      <td style={{ textAlign: "center" }}>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(props.saldo)}</td> */}
      <td>
        <span>
          <Button color="success" size="sm" onClick={toggle} id="Detalle">
            <i class="fas fa-file-alt"></i>
          </Button>
        </span>

        <Modal size="sm" isOpen={modal} toggle={toggle}>
  <ModalHeader toggle={toggle}><h4>Informacion del Proveedor</h4></ModalHeader>
          <ModalBody>
            <ProveedoresInfo idProveedor={props.idProveedor} />
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={toggle}>
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>

        {user.proveedores_create  ?(
        <Button color="info" id="Editar" size="sm" onClick={toggleEdit}>
          <i class="far fa-edit"></i>
        </Button>
        ):(
        <Button color="info" id="Editar" size="sm" disabled>
          <i class="far fa-edit"></i>
        </Button>
        )}

        {user.proveedores_create  ?(
        <Button color="warning" id="Login" size="sm" onClick={toggleLogin} className="ms-1">
          <i class="fas fa-key"></i>
        </Button>
        ):(
        <Button color="warning" id="Login" size="sm" disabled className="ms-1">
          <i class="fas fa-key"></i>
        </Button>
        )}

        <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
          <ModalHeader toggle={toggleEdit}>
            <h4>Editar Informacion de {props.nomcom}</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={4}>
                <Label>Nombre Comercial</Label>
                <Input
                  type="text"
                  placeholder="Nombre Comercial"
                  value={nombre_comercial}
                  required
                  onChange={(e) => {
                    setNombreComercial(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Razon Social</Label>
                <Input
                  type="text"
                  placeholder="Razon Social"
                  value={razon_social}
                  required
                  onChange={(e) => {
                    setRazonSocial(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>RFC</Label>
                <Input
                  type="text"
                  placeholder="RFC"
                  value={RFC}
                  required
                  onChange={(e) => {
                    setRFC(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Contacto</Label>
                <Input
                  type="text"
                  placeholder="Contacto"
                  value={contacto}
                  required
                  onChange={(e) => {
                    setContacto(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Telefono</Label>
                <Input
                  type="number"
min="0"
step="any"
                  placeholder="Telefono"
                  value={telefono}
                  required
                  onChange={(e) => {
                    setTelefono(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Email</Label>
                <Input
                  type="email"
                  placeholder="Email"
                  value={email}
                  required
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Label>Calle</Label>
                <Input
                  type="text"
                  placeholder="Calle"
                  value={calle}
                  required
                  onChange={(e) => {
                    setCalle(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>No. Ext</Label>
                <Input
                  type="text"
                  placeholder="No. Ext"
                  value={numero_ext}
                  required
                  onChange={(e) => {
                    setNumeroExt(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>No. Int</Label>
                <Input
                  type="text"
                  placeholder="No. Int"
                  value={numero_int}
                  required
                  onChange={(e) => {
                    setNumeroInt(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Pais</Label>
                <Input
                  type="text"
                  placeholder="Pais"
                  value={pais}
                  required
                  onChange={(e) => {
                    setPais(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Estado</Label>
                <Input
                  type="text"
                  placeholder="Estado"
                  value={estado}
                  required
                  onChange={(e) => {
                    setEstado(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Ciudad</Label>
                <Input
                  type="text"
                  placeholder="Ciudad"
                  value={ciudad}
                  required
                  onChange={(e) => {
                    setCiudad(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Delegacion</Label>
                <Input
                  type="text"
                  placeholder="Delegacion o Municipio"
                  value={delegacion}
                  required
                  onChange={(e) => {
                    setDelegacion(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Colonia</Label>
                <Input
                  type="text"
                  placeholder="Colonia"
                  value={colonia}
                  required
                  onChange={(e) => {
                    setColonia(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>CP</Label>
                <Input
                  type="number"
                  placeholder="CP"
                  value={cp}
                  required
                  onChange={(e) => {
                    setCP(e.target.value);
                  }}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={editProveedor}>
              Guardar
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal específico para gestión de login */}
        <Modal size="md" isOpen={modalLogin} toggle={toggleLogin}>
          <ModalHeader toggle={toggleLogin} style={{ backgroundColor: '#fff', color: '#333' }}>
            <h4 style={{ margin: 0, color: '#333' }}>
              <i className="fas fa-key me-2" style={{ color: '#ffc107' }}></i>
              Gestionar Acceso de Login - {props.nomcom}
            </h4>
          </ModalHeader>
          <ModalBody style={{ backgroundColor: '#fff', padding: '20px' }}>
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '20px',
              borderRadius: '8px',
              border: '1px solid #dee2e6'
            }}>
              <h6 style={{
                marginBottom: '20px',
                color: '#495057',
                fontWeight: 'bold'
              }}>
                <i className="fas fa-info-circle me-2" style={{ color: '#17a2b8' }}></i>
                Configuración de Acceso al Sistema
              </h6>
              
              <div style={{
                marginBottom: '20px',
                padding: '15px',
                backgroundColor: '#fff',
                borderRadius: '6px',
                border: '1px solid #e9ecef'
              }}>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="loginActiveCheck"
                    checked={login_active}
                    onChange={(e) => {
                      setLoginActive(e.target.checked);
                      if (!e.target.checked) {
                        setPassword("");
                      }
                    }}
                    style={{ transform: 'scale(1.2)' }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="loginActiveCheck"
                    style={{
                      fontWeight: 'bold',
                      color: '#495057',
                      marginLeft: '8px',
                      fontSize: '15px'
                    }}
                  >
                    <i className="fas fa-sign-in-alt me-1" style={{ color: '#28a745' }}></i>
                    Habilitar acceso de login
                  </label>
                </div>
              </div>

              {login_active && (
                <div style={{
                  marginTop: '20px',
                  padding: '15px',
                  backgroundColor: '#fff',
                  borderRadius: '6px',
                  border: '1px solid #e9ecef'
                }}>
                  <Label style={{
                    fontWeight: 'bold',
                    color: '#495057',
                    marginBottom: '8px',
                    display: 'block'
                  }}>
                    <i className="fas fa-lock me-1" style={{ color: '#dc3545' }}></i>
                    Nueva Contraseña
                  </Label>
                  <Input
                    type="password"
                    placeholder="Ingrese nueva contraseña (dejar vacío para mantener actual)"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    style={{
                      backgroundColor: '#fff',
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '8px 12px'
                    }}
                  />
                  <small style={{
                    color: '#6c757d',
                    display: 'block',
                    marginTop: '5px',
                    fontSize: '12px'
                  }}>
                    <i className="fas fa-exclamation-triangle me-1" style={{ color: '#ffc107' }}></i>
                    Dejar vacío para mantener la contraseña actual
                  </small>
                </div>
              )}

              <div style={{
                marginTop: '20px',
                padding: '12px 15px',
                backgroundColor: login_active ? '#d4edda' : '#f8d7da',
                color: login_active ? '#155724' : '#721c24',
                borderRadius: '6px',
                border: `1px solid ${login_active ? '#c3e6cb' : '#f5c6cb'}`
              }}>
                <small style={{ fontWeight: 'bold' }}>
                  <i className={`fas ${login_active ? 'fa-check-circle' : 'fa-times-circle'} me-1`}></i>
                  Estado actual: {props.login_active ? 'Acceso habilitado' : 'Acceso deshabilitado'}
                </small>
              </div>
            </div>
          </ModalBody>
          <ModalFooter style={{ backgroundColor: '#fff', borderTop: '1px solid #dee2e6' }}>
            <Button
              color="success"
              onClick={editProveedorLogin}
              style={{
                backgroundColor: '#28a745',
                borderColor: '#28a745',
                fontWeight: 'bold'
              }}
            >
              <i className="fas fa-save me-1"></i>
              Guardar Configuración
            </Button>
            <Button
              color="secondary"
              onClick={toggleLogin}
              style={{
                backgroundColor: '#6c757d',
                borderColor: '#6c757d',
                fontWeight: 'bold'
              }}
            >
              <i className="fas fa-times me-1"></i>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        {user.proveedores_create  ?(
        <Baja
          idStatus={props._id}
          is_active={props.is_active}
          URL_BAJA={import.meta.env.VITE_URL_PROVEEDORES}
        />
        ):undefined}
      </td>
    </>
  );
}

export default TablaProveedores;
